import { useState, useEffect } from 'react';

// Igual que useState, pero recuerda el valor en sessionStorage bajo `key`.
// Sirve para que los filtros de una lista sobrevivan al abrir un detalle y
// volver (la página se remonta pero el filtro se restaura). Se limpia al
// cerrar la pestaña.
export function useSessionState(key, initial) {
  const [val, setVal] = useState(() => {
    try {
      const v = sessionStorage.getItem(key);
      return v !== null ? JSON.parse(v) : initial;
    } catch { return initial; }
  });
  useEffect(() => {
    try { sessionStorage.setItem(key, JSON.stringify(val)); } catch { /* modo privado */ }
  }, [key, val]);
  return [val, setVal];
}

export default useSessionState;
